/* 
Author:Lamiaa Moustafa
Desc: Pop Account UI componenet
*/
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FaPlus } from "react-icons/fa";
import { RiLogoutBoxLine } from "react-icons/ri";
import ProfilePhoto1st2911 from "../../components/ProfilePhoto1st2911";
import Text1st2911 from "../../components/text/Text1st2911";
import {
  PopupDiv,
  AvatarDiv,
  AvatarPhotoDiv,
  FlexDiv,
} from "../../Styles/styledComponents/Divs";

const ListIconsNav = {
  color: "var(--orange)",
  fontSize: "18px",
  marginRight: "10px",
  marginTop: "5px",
};

const LogoutIconStyle = {
  color: "var(--orange)",
  fontSize: "21px",
  marginRight: "10px",
  marginTop: "5px",
};
//Avatar profile image style
const avatarStyle = {
  borderRadius: "100%",
  backgroundColor: "var(--lightGray)",
  border: "1px solid orange",
  width: "60px",
  height: "60px",
  // marginLeft: "15px",
};

const emailStyle = {
  color: "var(--darkGray)",
  fontSize: "1em",
  lineHeight: "1em",
  fontWeight: "var(--regularFont)",
  paddingLeft: "10px",
};

const AccountPopup = () => {
  return (
    <>
      <AvatarDiv>
        <AvatarPhotoDiv>
          <ProfilePhoto1st2911
            data={{
              source: require(`../../assets/pngs/Avatar.png`),
              customStyle: avatarStyle,
            }}
          />
        </AvatarPhotoDiv>
        <AvatarTextDiv>
          <Text1st2911
            data={{ text: "Lamiaa Moustafa", customStyle: emailStyle }}/>
          <Text1st2911
            data={{ text: "mia@gmail.com", customStyle: emailStyle }}/>
        </AvatarTextDiv>
      </AvatarDiv>
      <PopupDiv>
        <FlexDiv>
          <FaPlus style={ListIconsNav} />
          <NavLink to="/manageaccount">Manage account</NavLink>
        </FlexDiv>
      </PopupDiv>
      <PopupDiv>
        <FlexDiv>
          <RiLogoutBoxLine style={LogoutIconStyle} />
          <NavLink to="/">Logout</NavLink>
        </FlexDiv>
      </PopupDiv>
    </>
  );
};
export default AccountPopup;

const NavLink = styled(Link)`
  color: var(--Gray);
  font-family: var(--fontFamily);
  display: flex;
  height: 100%;
  cursor: pointer;
  font-size: 18px;
  letter-spacing: 1.2px;
  &:hover {
    color: var(--orange);
    transform: scale(0.95);
    transition: all 0.5s ease-in-out;
    text-decoration: underline;
  }
  /* &.active {
    font-weight: var(--boldFont);
    text-decoration: underline;
  } */
`;

//avatar info name and email style
const AvatarTextDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  p {
    margin-left: 0 !important;
    line-height: 5px !important;
  }
`;
